import { Empty } from '~/container';

export default function emptyPage() {
  return <Empty />;
}
